import React from 'react';

const ReferralTermsView = () => {
    return (
        <div className="referral-terms-view" style={{
            maxWidth: '900px',
            margin: '40px auto',
            padding: '40px',
            background: 'var(--card-bg)',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            color: 'var(--text-primary)'
        }}>
            <header style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h1 style={{
                    fontSize: '2.5rem',
                    background: 'linear-gradient(135deg, #4caf50 0%, #81c784 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    marginBottom: '10px'
                }}>
                    Programa de Referidos XCoin
                </h1>
                <p style={{ fontSize: '1.2rem', opacity: 0.8 }}>
                    Invita, comparte y ganen juntos bonos exclusivos en XCO.
                </p>
            </header>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ color: '#4caf50', borderBottom: '2px solid rgba(76,175,80,0.2)', paddingBottom: '10px' }}>
                    ¿Cómo Funciona?
                </h2>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '20px' }}>
                    <div style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px' }}>
                        <h3 style={{ margin: '0 0 10px 0', color: '#81c784' }}>1. Tú Invitas</h3>
                        <p>Comparte tu enlace único de referidos con amigos, familiares o en tus redes sociales.</p>
                    </div>
                    <div style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px' }}>
                        <h3 style={{ margin: '0 0 10px 0', color: '#81c784' }}>2. Ellos Compran</h3>
                        <p>Cuando tu referido compra XCoin usando tu enlace, ambos activan sus bonos automáticamente.</p>
                    </div>
                </div>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ color: '#ffeb3b', borderBottom: '2px solid rgba(255,235,59,0.2)', paddingBottom: '10px' }}>
                    Los Bonos
                </h2>
                <div style={{ display: 'flex', gap: '30px', marginTop: '20px', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, background: 'linear-gradient(135deg, rgba(76,175,80,0.1) 0%, rgba(76,175,80,0.2) 100%)', padding: '30px', borderRadius: '16px', border: '1px solid #4caf50', textAlign: 'center' }}>
                        <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#4caf50' }}>3%</div>
                        <h3 style={{ margin: '10px 0' }}>Bono para Ti</h3>
                        <p style={{ opacity: 0.9 }}>Recibes el 3% de la cantidad de XCO que compre tu referido.</p>
                    </div>
                    <div style={{ flex: 1, background: 'linear-gradient(135deg, rgba(255,152,0,0.1) 0%, rgba(255,152,0,0.2) 100%)', padding: '30px', borderRadius: '16px', border: '1px solid #ff9800', textAlign: 'center' }}>
                        <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#ff9800' }}>1%</div>
                        <h3 style={{ margin: '10px 0' }}>Bono para tu Amigo</h3>
                        <p style={{ opacity: 0.9 }}>Tu referido recibe un 1% EXTRA de XCO sobre su compra.</p>
                    </div>
                </div>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ color: '#9c27b0', borderBottom: '2px solid rgba(156, 39, 176, 0.2)', paddingBottom: '10px' }}>
                    Beneficios de por Vida y Seguimiento
                </h2>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '20px' }}>
                    <div style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #9c27b0' }}>
                        <h3 style={{ margin: '0 0 10px 0', color: '#ce93d8' }}>Comisiones Eternas</h3>
                        <p>
                            Tu enlace no es solo para la primera compra. <strong>Cada vez que tu referido compre XCO en el futuro</strong>, volverás a recibir tu bono del 3% (siempre respetando la regla de Crecimiento Neto).
                            ¡Construye una cartera de ingresos pasivos recurrentes!
                        </p>
                    </div>
                    <div style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #2196f3' }}>
                        <h3 style={{ margin: '0 0 10px 0', color: '#90caf9' }}>Control Total (Estados)</h3>
                        <ul style={{ paddingLeft: '20px', margin: 0, lineHeight: '1.6' }}>
                            <li><strong>⏳ Invitado:</strong> Ingresó su correo pero aún no crea cuenta.</li>
                            <li><strong>✅ Registrado:</strong> Ya creó su cuenta en XCoin.</li>
                            <li><strong>Inversionista:</strong> Ya compró XCO y te generó comisión.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ color: '#2196f3', borderBottom: '2px solid rgba(33,150,243,0.2)', paddingBottom: '10px' }}>
                    Términos y Condiciones (Letra Chica)
                </h2>
                <ul style={{ lineHeight: '1.8', opacity: 0.9, paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>Periodo de Bloqueo (Vesting):</strong> Los bonos (tanto el 3% como el 1%) se acreditan inmediatamente en estado <em>"Bloqueado"</em>. Permanecerán así por un periodo de <strong>90 días</strong>.
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>Requisito de Mantenimiento:</strong> Para que los bonos se liberen tras los 90 días, el usuario referido (quien hizo la compra) <strong>debe mantener</strong> los XCoin originales en su billetera.
                    </li>
                    <li style={{ marginBottom: '10px', color: '#4caf50' }}>
                        <strong>✅ Staking Permitido:</strong> Depositar tus XCoin en Staking (Renta Fija) <strong>SÍ se considera mantenerlos en tu poder</strong>. Puedes generar intereses mientras cumples el requisito de los 90 días.
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        Si el referido vende o transfiere parcial o totalmente sus XCoin (fuera de la plataforma o a otros usuarios) antes de los 90 días, <strong>ambos bonos serán cancelados</strong>.
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        Este sistema está diseñado para premiar a los verdaderos <em>Holders</em> y fortalecer la economía de XCoin a largo plazo.
                    </li>
                    <li style={{ marginBottom: '10px', width: '100%', borderTop: '1px dashed #666', paddingTop: '10px', marginTop: '20px' }}>
                        <strong style={{ color: '#ff9800', fontSize: '1.1rem' }}>Regla de Crecimiento Neto (Anti-Abuso):</strong>
                        <p style={{ margin: '5px 0' }}>
                            Para evitar manipulaciones (ej: vender y volver a comprar para generar bonos repetidos), los bonos SOLO se generan sobre el <strong>Crecimiento Neto</strong> de tu cartera.
                        </p>
                        <ul style={{ listStyleType: 'circle', paddingLeft: '20px', fontSize: '0.9rem', color: '#555' }}>
                            <li>Si tienes 3 XCO y compras 3 más (Total 6 XCO) = Bono sobre 3 XCO.</li>
                            <li>Si vendes los 3 XCO (Total 3 XCO) y vuelves a comprar 4 XCO (Total 7 XCO) = Bono SOLO sobre 1 XCO (la diferencia real).</li>
                        </ul>
                    </li>
                </ul>
            </section>

            <section style={{ background: 'rgba(255,255,255,0.03)', padding: '20px', borderRadius: '12px', textAlign: 'center' }}>
                <h3 style={{ marginTop: 0 }}>Ejemplo Práctico</h3>
                <p>
                    Si invitas a Ana y ella compra <strong>10.000 XCO</strong>:
                </p>
                <div style={{ display: 'inline-block', textAlign: 'left', margin: '20px 0' }}>
                    <div>✅ Tú recibes: <strong>300 XCO</strong> (Bono 3%)</div>
                    <div>✅ Ana recibe: <strong>10.100 XCO</strong> (Su compra + 100 XCO de Bono 1%)</div>
                </div>
                <p style={{ fontStyle: 'italic', fontSize: '0.9rem', opacity: 0.7 }}>
                    Ambos deben esperar 90 días con los fondos en la billetera para poder retirar o vender esos bonos.
                </p>
            </section>
        </div>
    );
};

export default ReferralTermsView;
